import React from "react";
import {Link} from "react-router-dom";
import {ZhuangziTitle} from "./Zhuangzi";

function LordOfTheCenter() {
    return (
        <div className="row">
            <div className="col-md-8 offset-md-2">
                <h1 className="text-center"><Link to="/translation/zhuangzi/lord-of-the-center">Lord of the
                    Center</Link></h1>
                <ZhuangziTitle/>
                <div className="text-center">
                    <a href="https://ctext.org/zhuangzi/normal-course-for-rulers-and-kings/zh#n2769">Original Text</a>
                </div>
                <hr/>
                <p>
                    The South Sea’s Lord was Shu,<br/>
                    The North Sea’s Lord was Hu;<br/>
                    Chaos was Lord of the Center.
                </p>
                <p>
                    Shu at times met Hu<br/>
                    In the land of Chaos,<br/>
                    Who to them was most kind.
                </p>
                <p>
                    Shu and Hu schemed<br/>
                    To repay this kindness,<br/>
                    Saying:
                </p>
                <p>
                    “All people have seven holes<br/>
                    To see, hear, eat and breathe;<br/>
                    Chaos alone lacks these.
                </p>
                <p>
                    Let’s try to chisel some!”
                </p>
                <p>
                    Each day they carved one hole;<br/>
                    In seven days Chaos died.
                </p>
                <p>
                    <strong>莊子，“應帝王” <br/> (Zhuangzi, "Answering Monarchs")</strong>
                </p>
                <p>
                    <em>Trans. Porter James, 2024-01-01</em>
                </p>
            </div>
        </div>
    );
}

export default LordOfTheCenter
